export default {
  // ======================= COMMON =========================

  SET_APP_MENU(state, data) {
    state.appMenu = data;
  },
  SET_APPL_YMD(state, data) {
    state.applYmd = data;
  },
  SET_REQ_S_HM(state, data) {
    state.reqSHm = data;
  },
  SET_REQ_E_HM(state, data) {
    state.reqEHm = data;
  },
  SET_REQUEST_HOUR(state, data) {
    state.requestHour = data;
  },
  SET_S_YMD(state, data) {
    state.sYmd = data;
  },
  SET_E_YMD(state, data) {
    state.eYmd = data;
  },
  SET_REASON(state, reason) {
    state.reason = reason;
  },
  //2025.03.12 연장근무신청 연장근무정보 직접입력 기능 추가
  SET_OT_INFO_DIRECT_YN(state, data) {
    state.otInfoDirectYn = data;
  },
  SET_DIRECT_REQUEST_HOUR(state, data) {
    state.directRequestHour = data;
  },
  SET_DIRECT_REST_HOUR(state, data) {
    state.directRestHour = data;
  },
  SET_REASON_FLAG(state, reasonFlag) {
    state.reasonFlag = reasonFlag;
  },
  // ======================= ATTEND =======================
  SET_ATTEND_PARAM(state) {
    state.attendParam = {
      bfShm: state.bfShm,
      bfEhm: state.bfEhm,
      afShm: state.reqSHm,
      afEhm: state.reqEHm,
      workYmd: state.workYmd,
      workWeek: state.workWeek,
      reason: state.reason,
    };
  },
  SET_BEFORE_START_HM(state, data) {
    state.bfShm = data;
  },
  SET_BEFORE_END_HM(state, data) {
    state.bfEhm = data;
  },
  // ======================= REWARD =======================
  SET_REWARD_PARAM(state) {
    state.rewardParam = {
      gntCd: state.gntCd.code,
      sYmd: state.sYmd,
      sYmdWeek: state.sYmdWeek,
      eYmd: state.eYmd,
      eYmdWeek: state.eYmdWeek,
      holDay: state.holDay,
      closeDay: state.closeDay,
      requestHour: state.requestHour,
      reason: state.reason,
      // mergeRows: state.rewardList,
    };
  },

  SET_REWARD_LIST(state, data) {
    state.rewardList = data;
  },
  SET_USE_REWARD_LIST(state, data) {
    state.useRewardList = data;
  },
  SET_REQ_TIME(state, data) {
    state.reqTime = data;
  },
  // ======================= SCHEDULE =======================
  SET_SCHEDULE_PARAM(state) {
    state.scheduleParam = {
      workOrgCd: state.workOrgCd,
      intervalCd: state.intervalCd,
      sdate: state.sYmd,
      edate: state.eYmd,
      stdYmd: state.stdYmd,
      dayGubunCd: state.dayGubunCd,
      timeCd: state.scheduleTimeCd,
      note: state.reason,
    };
  },
  SET_SEARCH_WORK_TYPE_CD(state, data) {
    state.searchWorkTypeCd = data;
  },
  SET_WORK_ORG_CD(state, data) {
    state.workOrgCd = data;
  },
  SET_INTERVAL_CD(state, data) {
    state.intervalCd = data;
  },
  SET_STD_YMD(state, data) {
    state.stdYmd = data;
  },
  SET_DAY_GUBUN_CD(state, data) {
    state.dayGubunCd = data;
  },
  SET_WORK_ORG_NM(state, data) {
    state.workOrgNm = data;
  },
  SET_WORK_ORG_TIME_LIST(state, data) {
    state.workOrgTimeList = data;
  },
  SET_SCHEDULE_TIME_CD(state, data) {
    state.scheduleTimeCd = data;
  },
  SET_SCHEDULE_TIME_NM(state, data) {
    state.scheduleTimeNm = data;
  },

  // ======================= OTWORK =========================
  SET_OTWORK_PARAM(state) {
    state.otworkParam = {
      reqTimeCd: state.reqTimeCd,
      workYmd: state.workYmd,
      workWeek: state.workWeek,
      restHour: state.restHour,
      inoutYn: state.inoutYn,
      alterYmd: state.alterYmd,
      alterWeek: state.alterWeek,
      alterGntCd: state.alterGntCd,
      reason: state.reason,
      applYmd: state.applYmd,
      reqSHm: state.reqSHm,
      reqEHm: state.reqEHm,
      requestHour: state.requestHour,
      holOtHour: state.holOtHour,
      hour: state.hour,
      otInfoDirectYn: state.otInfoDirectYn,
      directRequestHour: state.directRequestHour,
      directRestHour: state.directRestHour,
    };
  },
  SET_REQ_TIME_CD(state, data) {
    state.reqTimeCd = data;
  },
  SET_ALTVAC_APPL_STATUS(state, data) {
    state.altvacApplStatus = data;
  },
  SET_ALTER_GNT_NM(state, data) {
    state.alterGntNm = data;
  },
  SET_WORK_YMD(state, data) {
    state.workYmd = data;
  },
  SET_WORK_WEEK(state, data) {
    state.workWeek = data;
  },
  SET_HOL_YN(state, data) {
    state.holYn = data;
    if (data === 'N') {
      state.reqTimeCd = '';
      state.alterYmd = '';
    }
  },
  // 연장근무 신청 사전(B)/사후(A)
  SET_APPL_GUBUN(state, data) {
    // 사후 일때만 출퇴근 반영
    state.applGubun = data;
    state.inoutYn = data === 'A' ? 'Y' : 'N';
  },

  // 출퇴근시간
  SET_IN_OUT(state, data) {
    state.inOut = data;
    if (data.inOut !== null && data.inOut !== '|') {
      const inOut = data.inOut.split('|');
      state.reqSHm = inOut[0];
      state.reqEHm = inOut[1];
    } else if (data.stdHm !== null) {
      const stdHm = data.stdHm.split('|');
      state.reqSHm = stdHm[0];
      state.reqEHm = stdHm[1];
    } else {
      state.reqSHm = '';
      state.reqEHm = '';
    }
  },
  // 제외 휴게시간
  SET_REST_HOUR(state, data) {
    state.restHour = data;
  },
  // 출퇴근시간 반영 여부 값
  SET_IN_OUT_YN(state, data) {
    state.inoutYn = data;
  },
  // 대체휴가 정보
  SET_ALTER_YMD(state, data) {
    state.alterYmd = data;
  },
  SET_ALTER_WEEK(state, data) {
    state.alterWeek = data;
  },
  SET_ALTER_GNT_CD(state, data) {
    state.alterGntCd = data;
  },
  SET_HOL_OT_HOUR(state, data) {
    state.holOtHour = data;
  },
  SET_BASIC_HOUR(state, data) {
    state.hour = data;
  },
  //
  // ======================= PLAN =======================

  SET_PLAN_PARAM(state, data) {
    state.planParam = {
      gntCd: state.gntCd.code,
      sYmd: state.sYmd,
      eYmd: state.eYmd !== undefined ? state.eYmd : data.eYmd,
    };
  },
  // ======================= VACATION =======================

  SET_VACATION_PARAM(state, data) {
    state.vacationParam = {
      baseCnt: state.gntCd.baseCnt,
      maxCnt: state.gntCd.maxCnt,
      gntCd: state.gntCd.code,
      gntGubunCd: state.gntGubunCd,
      sYmd: state.sYmd,
      eYmd: state.eYmd !== undefined ? state.eYmd : data.eYmd,
      reason: state.reason,
      holDay: state.holDay,
      closeDay: state.closeDay,

      applYmd: state.applYmd,
      applYmdWeek: state.applYmdWeek,
      holWorkYmd: state.holWorkYmd,
      holWorkYmdCombo: state.holWorkYmdCombo,
      sYmdWeek: state.sYmdWeek,
      eYmdWeek: state.eYmdWeek,
      reqSHm: state.reqSHm,
      reqEHm: state.reqEHm,
      requestHour: state.requestHour,

      searchApplCd: state.searchApplCd,
      searchGntGubunCd: state.gntGubunCd,
    };
  },
  SET_GNT_GUBUN_CD(state, data) {
    state.gntGubunCd = data;
  },
  SET_GNT_CD(state, data) {
    state.gntCd = data;
  },
  SET_S_YMD_WEEK(state, data) {
    state.sYmdWeek = data;
  },
  SET_E_YMD_WEEK(state, data) {
    state.eYmdWeek = data;
  },
  /*
   * 전체일수/적용일수 적용
   * 적용일수 = 전체일수 - 휴일
   */
  SET_CLOSE_DAY(state, holidayMapData) {
    var holDay = holidayMapData.holDay;
    if (state.halfYn === 'N') {
      state.holDay = holDay;
      state.closeDay = holDay - holidayMapData.holidayCnt;
    } else if (state.halfYn === 'Y') {
      // 반차휴가
      state.holDay = '0.5';
      state.closeDay = '0.5';
    } else if (state.halfYn === 'TQ') {
      // 반반차+반차휴가 2024-06-28 ejkim 추가
      state.holDay = '0.75';
      state.closeDay = '0.75';
    } else {
      // 반반차
      state.holDay = '0.25';
      state.closeDay = '0.25';
    }
  },
  SET_CLOSE_DAY_DATA(state, data) {
    state.closeDay = data;
  },
  // 반차 여부
  SET_HALF_YN(state) {
    const reqUseType = state.gntCd.requestUseType;
    if (reqUseType === 'AM' || reqUseType === 'PM') {
      state.halfYn = 'Y';
    } else if (reqUseType === 'QT1' || reqUseType === 'QT4') {
      state.halfYn = 'HY';
    } else if (reqUseType === 'TQ1' || reqUseType === 'TQ2') {
      //반반차+반차
      state.halfYn = 'TQ';
    } else if (state.gntGubunCd === '11') {
      state.halfYn = 'N';
    } else {
      state.halfYn = 'N';
    }
  },
  SET_ALTER_VACATION(state, data) {
    state.alterVacation = data;
  },
  SET_APPL_YMD_WEEK(state, data) {
    state.applYmdWeek = data;
  },
  SET_HOL_WORK_YMD(state, data) {
    state.holWorkYmd = data;
  },
  SET_HOL_WORK_YMD_COMBO(state, data) {
    state.holWorkYmdCombo = data;
  },
  //2025.03.19 근태별 파일첨부 필수여부
  SET_GNT_FILE_ESS_YN(state, data) {
    state.gntFileEssYn = data;
  },

  // ======================= BIZTRIP =======================
  /** 출장신청서구분명 셋팅 */
  SET_BIZ_TRIP_GNT_NM(state, data) {
    state.bizTripGntNm = data;
  },
  /** 출장신청서 상세 데이터 셋팅 */
  SET_BIZ_TRIP_DET(state, data) {
    // 1. 초기화
    state.bizTripCols = []; // 전체항목
    state.bizTripDynamicCols = []; // 동적컬럼(항목)
    state.bizTripTitle = {}; // 고정컬럼(항목) - 출장제목
    state.bizTripSabunNote = null; // 예외컬럼(항목) - 동행인추가항목(메모)
    state.bizTripData = {}; // 입력값
    state.bizTripJoiner = []; // 동행인 목록

    // 2. 원본 셋팅
    state.bizTripCols = data.col;
    state.bizTripData = data.data;
    state.bizTripJoiner = data.emp;

    // 3. 고정컬럼과 동적컬럼 분리 후 셋팅
    data.col.forEach(item => {
      if (
        item.columnId !== 'DATE' &&
        item.columnId !== 'TITLE' &&
        item.columnId !== 'SABUN' &&
        item.columnId !== 'SABUN_NOTE'
      ) {
        item.colVal = item.defCont || ''; // * 기본표시내용이 있으면 값을 기본으로 셋팅한다.
        state.bizTripDynamicCols.push(item);
      }
      if (item.columnId === 'TITLE') {
        item.colVal = item.defCont || '';
        state.bizTripTitle = item;
      }
      if (item.columnId === 'SABUN_NOTE') {
        item.userNote = item.defCont || '';
        state.bizTripSabunNote = item;
      }
    });
  },

  /**
   *  신청서작성용 컬럼셋팅 - 출장제목(고정컬럼)
   */
  SET_BIZ_TRIP_TITLE(state, data) {
    state.bizTripTitle.colVal = data;
  },

  /**
   *  신청서작성용 컬럼셋팅 - 동적컬럼
   */
  SET_BIZ_TRIP_DYNAMIC_COL(state, data) {
    // 이벤트에서 호출된(변경된) 값만 변경한다.
    const index = state.bizTripDynamicCols.findIndex(
      col => col.columnId === data.columnId,
    );
    state.bizTripDynamicCols[index].colVal = data.colVal;
  },

  /** 출장동행인목록 셋팅 */
  SET_BIZ_TRIP_JOINER(state, data) {
    state.bizTripJoiner = data;
  },

  /** 출장신청 입력항목 셋팅 */
  SET_BIZ_TRIP_DATA(state, data) {
    state.bizTripData = data;
  },

  // ======================= CERTI =======================
  SET_CERTI_PARAM(state) {
    state.certiParam = {
      purpose: state.purpose,
      submitOffice: state.submitOffice,
      address: state.address,
      addrYn: state.addrYn === 0 ? 'Y' : 'N',
      resNoYn: state.resNoYn === 0 ? 'Y' : 'N',
      gempYn: state.gempYn === 0 ? 'Y' : 'N',
      noteYn: state.noteYn === 0 ? 'Y' : 'N',
      periodYyCnt: state.periodYyCnt,
      periodMmCnt: state.periodMmCnt,
    };
  },

  SET_PURPOSE(state, data) {
    state.purpose = data;
  },
  SET_SUBMIT_OFFICE(state, data) {
    state.submitOffice = data;
  },
  SET_ADDRESS(state, data) {
    state.address = data;
  },
  SET_ADDR_YN(state, data) {
    state.addrYn = data;
  },
  SET_RES_NO_YN(state, data) {
    state.resNoYn = data;
  },
  SET_GEMP_YN(state, data) {
    state.gempYn = data;
  },
  SET_NOTE_YN(state, data) {
    state.noteYn = data;
  },
  SET_PERIOD_YY_CNT(state, data) {
    state.periodYyCnt = data;
  },
  SET_PERIOD_MM_CNT(state, data) {
    state.periodMmCnt = data;
  },
  SET_PURPOSE_CD_LIST(state, data) {
    state.purposeCdList = data;
  },

  // ======================= CANCEL =========================
  // 취소신청시 추가옵션화면 조회용 state 셋팅
  SET_VACATION_STATE(state, map) {
    state.sYmd = map.sYmd;
    state.eYmd = map.eYmd;
    state.reqSHm = map.reqSHm;
    state.reqEHm = map.reqEHm;
    state.gntGubunCd = map.gntGubunCd;
    state.requestHour = map.requestHour;
  },
  SET_SEARCH_BF_APPL_SEQ(state, data) {
    state.searchBfApplSeq = data;
  },

  /** 전체 초기화 */
  RESET_APPLICATION_STATE(state) {
    // ======================= COMMON =========================
    state.appMenu = {}; // 선택한 신청서 메뉴 정보
    state.reason = '';
    state.applYmd = '';
    state.reqSHm = '';
    state.reqEHm = '';
    state.requestHour = '';
    state.holOtHour = '';
    state.hour = '';
    state.sYmd = '';
    state.eYmd = '';
    state.sYmdWeek = '';
    state.eYmdWeek = '';
    state.holDay = ''; // 전체일수
    state.closeDay = ''; // 적용일수
    state.workYmd = '';
    state.workWeek = '';

    state.otInfoDirectYn = ''; //2025.03.12 연장근무정보 직접입력가능여부
    state.directRequestHour = ''; //2025.03.12 직접입력 신청시간
    state.directRestHour = ''; //2025.03.12 직접입력 휴게시간

    state.fileList = [];
    state.reasonFlag = '';
    // ======================= ATTEND =======================
    state.attendParam = {}; // 보상휴가 기본 파라미터
    state.bfShm = '';
    state.bfEhm = '';
    // ======================= REWARD =======================
    state.rewardParam = {}; // 보상휴가 기본 파라미터
    state.rewardList = [];
    state.useRewardList = []; // 사용한 보상휴가 목록
    state.reqTime = 0;
    // ======================= SCHEDULE =======================
    state.scheduleParam = {}; // 근무스케줄 기본 파라미터
    state.searchWorkTypeCd = '';
    state.workOrgCd = ''; // 근무유형 코드
    state.intervalCd = ''; // 근무주기
    state.stdYmd = '';
    state.dayGubunCd = '';
    state.scheduleTimeCd = ''; // 변경한 근무시간코드

    state.workOrgNm = '';
    state.workOrgTimeList = [];
    state.scheduleTimeNm = '';
    // ======================= OTWORK =========================
    state.otworkParam = {}; // 연장근무 기본 파라미터
    state.reqTimeCd = '';
    state.restHour = '';
    state.inoutYn = 'Y';
    state.alterYmd = '';
    state.alterWeek = '';
    state.alterGntCd = '';

    state.altvacApplStatus = 'N'; // 대체휴가자동신청 여부 및 신청상태 (N / 11~99)
    state.alterGntNm = '';
    state.holYn = 'N'; // 휴일여부
    state.applGubun = ''; // A: 사후, B: 사전
    state.inOut = '|'; // 출퇴근 시간
    // ======================= VACATION =======================
    state.vacationParam = {}; // 근태 기본 파라미터
    state.alterVacation = {}; // 선택한 휴일 근무일 정보
    state.gntCd = {}; // 근태명
    state.gntGubunCd = '';
    state.halfYn = 'N'; // 반차 여부
    state.restCnt = ''; // 잔여일수
    state.applYmdWeek = '';
    state.holWorkYmd = ''; // 대체휴일
    state.holWorkYmdCombo = '';
    state.gntFileEssYn = '';
    // ======================= BIZTRIP =======================
    state.bizTripGntNm = ''; // 출장신청 근태명
    state.bizTripCols = []; // 출장신청 입력항목 (**동적컬럼)
    state.bizTripTitle = {}; // 출장신청 제목 (**고정컬럼 | bizTripCols에서 추출한 값)
    state.bizTripSabunNote = null; // 출장신청동행인 추가항목 (**예외컬럼 | bizTripCols에서 추출
    state.bizTripDynamicCols = []; // 출장신청 동적컬럼 (** bizTripCols에서 추출한 값)
    state.bizTripData = {}; // 출장신청 입력내용 (기본표기내용이 있을 수 있음!)
    state.bizTripJoiner = []; // 출장신청 동행인 목록

    // ======================= CERTI =======================
    state.certiParam = {};
    state.purpose = '';
    state.submitOffice = '';
    state.address = '';
    state.addrYn = 1;
    state.resNoYn = 1;
    state.gempYn = 1;
    state.noteYn = 1;
    state.periodYyCnt = 0;
    state.periodMmCnt = 0;
    // ======================= CANCEL =======================
    state.searchBfApplSeq = ''; // 기존 신청서 seq
  },
};
